import { render, staticRenderFns } from "./InvoiceAttachmentsSection.vue?vue&type=template&id=28c0e74b"
import script from "./InvoiceAttachmentsSection.vue?vue&type=script&lang=js"
export * from "./InvoiceAttachmentsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports